import { Modal, Spin } from 'antd';
import React, { useState } from 'react';
import { updateShortUrl } from '../../services/URLShortnerService';
import ShortUrlForm from './components/ShortUrlForm';

function ShortUrlEdit(props) {
  const shortUrl = props.shortUrl;

  const initialValues = {
    name: shortUrl.name,
    longUrl: shortUrl.longUrl,
    urlCode: shortUrl.urlCode
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    const updatedValues = {
      name: values.name,
      longUrl: values.longUrl,
      urlCode: values.urlCode
    };

    await updateShortUrl(shortUrl._id, updatedValues)
      .then((response) => {
        setStatus({ type: 'SUCCESS', message: 'Data updated successfully!' });
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title="Edit Short Url"
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <ShortUrlForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default ShortUrlEdit;
